import React from 'react'
import Container from './Container.js'
export const SortableStressTest = (props) => {
  return <><Container {...props} /></>
}
